export default class Faq {
    constructor(element) {
        this.trigger = element.querySelector('.js-faq-trigger')
        this.outer = element.querySelector('.js-faq-outer')
        this.innerHeight = element.querySelector('.js-faq-inner').getBoundingClientRect().height

        this.trigger.addEventListener('click', () => {
            if (!this.trigger.classList.contains('content-open')) {
                this.trigger.classList.add('content-open')
                Object.assign(this.outer.style, {
                    height: this.innerHeight + 'px',
                })
            } else {
                this.trigger.classList.remove('content-open')
                Object.assign(this.outer.style, {
                    height: '0px',
                })
            }
        })
    }
}
